import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import AddIcon from "@material-ui/icons/Add";
import SaveIcon from "@material-ui/icons/Save";
// import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import { useFormikContext } from "formik";

import {
  Button,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@material-ui/core";
import { WatchHeader } from "../Components";

import {
  Step,
  Stepper,
  StepLabel,
  Badge,
  Paper,
} from "@material-ui/core";

import { authPut } from "../../../lib";
import {
  WatchModel,
  Pricing,
  Images,
  Case,
  Dial,
  BandAndBuckle,
  Movement,
} from "../Components";
import {
  WatchFormActions,
  useDispatch,
  WatchFormSelectors,
} from "../../../state";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  padding: {
    padding: 0,
  },
  margin: {
    margin: 0,
  },
  both: {
    padding: 0,
    margin: 0,
  },
  button: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  stickToBottom: {
    position: "fixed",
    bottom: 0,
    margin: 10,
  },
}));
function getSteps() {
  return [
    "Brand & Model",
    "Pricing & status",
    "Case description",
    "Dial description",
    "Band & Buckle",
    "Movement",
    "Images",
    "Review",
  ];
}

export const AddWatchStepper = (props) => {
  const siteId = 0; //useSelector((state) => state.scopes.site_id);
  const watchform = useSelector(WatchFormSelectors.watchform);
  const { values } = useFormikContext();
  const dispatch = useDispatch();
  // Populate watchform in Redux once on mount so WatchHeader can display title/status.
  // Do NOT re-run on every values change — that causes full re-renders of all form sections.
  useEffect(() => {
    dispatch(WatchFormActions.saveForm(values));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const classes = useStyles();
  const [activeStep, setActiveStep] = useState(props.isEdit ? 1 : 0);
  const [requiredBrandBadge, setRequiredBrandBadge] = useState(0);
  const [requiredPriceBadge, setRequiredPriceBadge] = useState(0);
  const [requiredImageBadge, setRequiredImageBadge] = useState(0);
  const [childCalibreData, setChildCalibreData] = useState({});
  const [isCalibreEdited, setIsCalibreEdited] = useState(false);
  const [badgeContentErrors, setBadgeContentErrors] = useState();
  // The model number the watch loaded with (captured once at mount).
  const [originalModelNum] = useState(values.model_no);
  // Fresh, trim-insensitive comparison every render — NOT a cached flag — so
  // focusing/clicking the model-number field without a real change (or a stray
  // trailing newline from the multiline input) can never fake a "changed" state
  // and let a duplicate through. The backend also re-checks DB uniqueness.
  const modelUnchanged =
    (values.model_no || "").trim() === (originalModelNum || "").trim();
  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    // The WatchHeader is position:sticky/top:0, so a plain scrollIntoView aligns
    // the section top to the viewport top where the header covers it. Set
    // scroll-margin-top to the sticky header's measured height (+ a small gap);
    // scrollIntoView honors it and lands the section title just below the
    // header. Using scrollIntoView (not window.scrollTo) keeps working whatever
    // element is the actual scroll container.
    const header = document.getElementById('watch-sticky-header');
    const headerH = header ? header.getBoundingClientRect().height : 0;
    el.style.scrollMarginTop = `${headerH + 16}px`;
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };
  useEffect(() => {
    setBadgeContentErrors(
      requiredBrandBadge + requiredPriceBadge + requiredImageBadge,
    );
  }, [requiredBrandBadge, requiredImageBadge, requiredPriceBadge]);
  // Deep-link from the grid's camera column: /edit-watch/:id#images opens here,
  // and we jump to the Images section once the sections have rendered. Clear the
  // hash afterward so a manual reload doesn't re-trigger the jump.
  useEffect(() => {
    if (window.location.hash !== '#images') return;
    const t = setTimeout(() => {
      scrollToSection('section-images');
      window.history.replaceState(null, '', window.location.pathname + window.location.search);
    }, 600);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const steps = getSteps();
  function ColorlibStepIcon(props) {
    const { active, completed } = props;

    const icons = {
      1: (
        <Badge badgeContent={requiredBrandBadge} color="secondary">
          <Button onClick={() => scrollToSection('section-watch')}>Brand & Model</Button>
        </Badge>
      ),
      2: (
        <Badge badgeContent={requiredPriceBadge} color="secondary">
          <Button onClick={() => scrollToSection('section-price')}>Pricing & Status</Button>
        </Badge>
      ),
      3: (
        <Badge badgeContent={requiredImageBadge} color="secondary">
          <Button onClick={() => scrollToSection('section-case')}>Case Description</Button>
        </Badge>
      ),
      4: (
        <Button onClick={() => scrollToSection('section-dial')}>Dial Description</Button>
      ),
      5: (
        <Button onClick={() => scrollToSection('section-band')}>Band & Buckle</Button>
      ),
      6: (
        <Button onClick={() => scrollToSection('section-movement')}>Movement</Button>
      ),
      7: (
        <Button onClick={() => scrollToSection('section-images')}>Images</Button>
      ),
      8: (
        <Button onClick={() => scrollToSection('section-watch')}>Review</Button>
      ),
    };

    return (
      <div
        className={clsx(classes.root, {
          [classes.active]: active,
          [classes.completed]: completed,
        })}
      >
        {icons[String(props.icon)]}
      </div>
    );
  }

  ColorlibStepIcon.propTypes = {
    active: PropTypes.bool,
    completed: PropTypes.bool,
    icon: PropTypes.node,
  };
  // const handleNext = () => {
  //   setActiveStep((prevActiveStep) => prevActiveStep + 1);
  // };

  const [open, setOpen] = useState(false);
  const [openDuplicate, setOpenDuplicate] = useState(false);

  const handleClickOpen = () => {
    setActiveStep(7);
    submit({ currentTarget: {} });
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleClickDuplicate = () => {
    setActiveStep(7);
    setOpenDuplicate(true);
  };
  const handleCloseDuplicate = () => {
    setOpenDuplicate(false);
  };

  //there are 2 or even 3 apis one is adding the new calibre to the database
  //one is adding images to the database on the submit not here
  //then after the props.submit form is adding the add watch to the database
  const submit = (e) => {
    if (e.currentTarget.id === "duplicate") {
      props.setDuplicate(true);
    } else props.setDuplicate(false);
    console.log("child calib", childCalibreData);
    if (childCalibreData.calibre_id && (childCalibreData.parent_calibre_id || isCalibreEdited)) {
      //replace true with a add new watch make sure your not reusing the edit watch from b4 that has a parent
      (async function () {
        const { data, error } = await authPut(
          `/calibre-details/${childCalibreData.calibre_id}`,
          {
            brand_id: childCalibreData.brand_id,
            calibre: childCalibreData.calibre,
            certification_ids: childCalibreData.certification_ids || [],
            description: childCalibreData.description,
            movement: childCalibreData.movement,
            parent_calibre_id: childCalibreData.parent_calibre_id,
            complications: childCalibreData.complications.filter(
              (value) => value !== false,
            ),
            complication_details: childCalibreData.complication_details.filter(
              (value) => value.calibre_id !== false,
            ),
          },
        );
        if (error) {
          alert("ERROR: " + error.message);
        } else {
          console.log(data);
        }
      })();
    } else {
      console.log("NO PARENT");
    }

    props.submitForm();
  };

  return (
    <div className={classes.root}>
      <WatchHeader
        watchId={props.watchId}
        isEdit={props.isEdit}
        data={watchform}
        retired={props.retired}
        statusID={props.statusID}
      />
      <Stepper activeStep={activeStep} className={classes.padding}>
        {steps.map((label, index) => (
          <Step key={index}>
            <StepLabel StepIconComponent={ColorlibStepIcon}></StepLabel>
          </Step>
        ))}
      </Stepper>
      <div id="section-watch" style={{ marginTop: 15, marginBottom: 15 }}>
        <WatchModel
          classes={props.classes}
          setFieldValue={props.setFieldValue}
          activeStep={activeStep}
          setActiveStep={setActiveStep}
          requiredBrandBadge={requiredBrandBadge}
          setRequiredBrandBadge={setRequiredBrandBadge}
          watchId={props.watchId}
          isEdit={props.isEdit}
        />
      </div>
      <div id="section-price" style={{ marginBottom: 15 }}>
        <Pricing
          tpc_retail={props.tpc_retail}
          setTpc_retail={props.setTpc_retail}
          classes={props.classes}
          activeStep={activeStep}
          setRequiredPriceBadge={setRequiredPriceBadge}
          requiredPriceBadge={requiredPriceBadge}
          setStatus={props.setStatus}
          setRetired={props.setRetired}
          setActiveStep={setActiveStep}
          isEdit={props.isEdit}
        />
      </div>
      <div id="section-case" style={{ marginBottom: 15 }}>
        <Case
          classes={props.classes}
          activeStep={activeStep}
          setActiveStep={setActiveStep}
        />
      </div>
      <div id="section-dial" style={{ marginBottom: 15 }}>
        <Dial
          classes={props.classes}
          activeStep={activeStep}
          setActiveStep={setActiveStep}
        />
      </div>
      <div id="section-band" style={{ marginBottom: 15 }}>
        <BandAndBuckle
          classes={props.classes}
          activeStep={activeStep}
          setActiveStep={setActiveStep}
        />
      </div>
      <div id="section-movement" style={{ marginBottom: 15 }}>
        <Movement
          classes={props.classes}
          activeStep={activeStep}
          setChildCalibreData={setChildCalibreData}
          childCalibreData={childCalibreData}
          setActiveStep={setActiveStep}
          setIsCalibreEdited={setIsCalibreEdited}
        />
      </div>
      <div id="section-images">
        <Images
          classes={props.classes}
          photosByFeed={props.photosByFeed}
          setPhotosByFeed={props.setPhotosByFeed}
          itemId={props.watchId}
          modelNo={values.model_no}
          brandId={values.brand_id}
          seriesId={values.series_id}
          isEdit={props.isEdit}
        />
      </div>
      <Paper
        style={{
          width: "fit-content",
          position: "fixed",
          bottom: 16,
          right: 24,
          zIndex: 1500,
          borderTop: "1px solid rgba(0, 0, 0, 0.08)",
        }}
        elevation={2}
      >
        <Box
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
          style={{ padding: "8px 16px", gap: 8 }}
        >
          {props.isEdit && siteId === 0 && (
            <Badge badgeContent={badgeContentErrors} color="secondary">
              <Button
                variant="outlined"
                color="primary"
                startIcon={<FileCopyIcon />}
                id={"duplicate"}
                onClick={handleClickDuplicate}
                disabled={!!badgeContentErrors || !values.size_id}
              >
                Duplicate
              </Button>
            </Badge>
          )}
          {/* {activeStep < 7 && (
            <Button
              variant="outlined"
              color="primary"
              endIcon={<ArrowForwardIcon />}
              onClick={handleNext}
            >
              Next
            </Button>
          )} */}
          <Badge badgeContent={badgeContentErrors} color="secondary">
            <Button
              variant="contained"
              color="primary"
              startIcon={props.isEdit ? <SaveIcon /> : <AddIcon />}
              onClick={handleClickOpen}
              disabled={!!badgeContentErrors || !values.size_id}
            >
              {props.isEdit ? "Update" : "Add"}
            </Button>
          </Badge>
        </Box>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {badgeContentErrors
              ? "Uh-oh!"
              : props.isEdit
              ? "Confirm to Edit"
              : "Confirm to Add"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {badgeContentErrors
                ? "Seems that not all required fields were filled in. Please review and fill in the required fields."
                : props.isEdit
                ? "Are you sure you want to save changes for this watch?"
                : "Are you sure you want to Add this watch?"}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary" variant="outlined">
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={submit}
              color="primary"
              autoFocus
              disabled={!!badgeContentErrors || !values.size_id}
            >
              {props.isEdit ? "Save" : "Add"}
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={openDuplicate}
          onClose={handleCloseDuplicate}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {badgeContentErrors || modelUnchanged
              ? "Uh-oh!"
              : "Confirm Duplicate"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {badgeContentErrors
                ? "Seems that not all required fields were filled in. Please review and fill in the required fields."
                : modelUnchanged
                ? "Model number must be changed before duplicating."
                : "A new watch record will be created with all current field values. Images will not be carried over."}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleCloseDuplicate}
              color="primary"
              variant="outlined"
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={submit}
              id={"duplicate"}
              color="primary"
              autoFocus
              disabled={badgeContentErrors || modelUnchanged || !values.size_id}
            >
              Duplicate
            </Button>
          </DialogActions>
        </Dialog>
      </Paper>
    </div>
  );
};
